module.exports = __webpack_public_path__ + "img/homePad_one_logo.3e4c069a.svg";